mutation StartStreamPull($contentId: ID!, $sourceUrl: String!) {
  startStreamPull(contentId: $contentId, sourceUrl: $sourceUrl) {
    id
    stream {
      id
      pull {
        sourceUrl
        status
        attempt
        maxAttempts
        startedAt
        finishedAt
        lastError {
          code
          message
        }
      }
    }
  }
}
